module.exports = __webpack_public_path__ + "img/ico-world.b36e3df3.svg";